import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "m-auto px-8" }
const _hoisted_2 = { class: "m-auto pt-3" }
const _hoisted_3 = { class: "py-10 flex justify-between" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex justify-between items-center" }
const _hoisted_6 = { class: "pb-8" }
const _hoisted_7 = { class: "flex justify-end pt-2" }
const _hoisted_8 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_TableTooltip = _resolveComponent("TableTooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, {
        visible: _ctx.loading||_ctx.listaProgetti.loading
      }, null, 8, ["visible"])
    ])),
    _cache[7] || (_cache[7] = _createElementVNode("div", { id: "selectModal" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.paths }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
              class: "w-48 hidden text-sm sm:block py-2 px-4"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" < Indietro ")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "font-bold text-xl mb-3" }, "Sottoprogetti", -1)),
          _createVNode(_component_Switcher, {
            modelValue: _ctx.tab_show,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab_show) = $event)),
            options: ['Tutti', 'Chiusi', 'Aperti'],
            class: "whitespace-nowrap mr-3"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Paginator, {
              class: "",
              pagination: _ctx.listaProgetti.paginate
            }, null, 8, ["pagination"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_NextTable, {
              class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed",
              cols: _ctx.progettiCols,
              "onUpdate:cols": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.progettiCols) = $event)),
              rows: _ctx.progetti,
              onOrderUpdate: _ctx.listaProgetti.updateCols
            }, _createSlots({ _: 2 }, [
              _renderList(_ctx.progetti, (c, j) => {
                return {
                  name: `td_${j}_2`,
                  fn: _withCtx(() => [
                    _createVNode(_component_TableTooltip, { inner_class: "relative" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.accounts, (option, i) => {
                          return (_openBlock(), _createBlock(_component_MultiselectOption, {
                            key: i,
                            readonly: "true"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(option.name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ])
                }
              }),
              _renderList(_ctx.progetti, (c, j) => {
                return {
                  name: `td_${j}_4`,
                  fn: _withCtx((context) => [
                    _createTextVNode(_toDisplayString(context.context.row.business_unit?.label), 1)
                  ])
                }
              }),
              _renderList(_ctx.progetti, (c, j) => {
                return {
                  name: `td_${j}_5`,
                  fn: _withCtx((context) => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_inizio)), 1)
                  ])
                }
              }),
              _renderList(_ctx.progetti, (c, j) => {
                return {
                  name: `td_${j}_6`,
                  fn: _withCtx((context) => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_fine)), 1)
                  ])
                }
              }),
              _renderList(_ctx.progetti, (c, j) => {
                return {
                  name: `td_${j}_7`,
                  fn: _withCtx((context) => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.context.row.budget)), 1)
                  ])
                }
              }),
              _renderList(_ctx.progetti, (c, j) => {
                return {
                  name: `td_${j}_9`,
                  fn: _withCtx((context) => [
                    _createVNode(_component_router_link, {
                      to: {name:'DettaglioProgetto', params:{id:context.context.row.progetto_id}},
                      class: "block text-center inset-0 absolute flex items-center justify-center"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                      ])),
                      _: 2
                    }, 1032, ["to"])
                  ])
                }
              })
            ]), 1032, ["cols", "rows", "onOrderUpdate"])
          ]),
          _createVNode(_component_InfiniteLoading, {
            onInfinite: _ctx.listaProgetti.fetchNextPage,
            identifier: _ctx.listaProgetti.infiniteIdentifier,
            style: {"min-height":"1px"}
          }, {
            complete: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri sottoprogetti.", -1)
            ])),
            _: 1
          }, 8, ["onInfinite", "identifier"])
        ])
      ])
    ])
  ], 64))
}